import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { ServiceValuationLanding } from './types';

export function useServiceValuationLandingData(): Page<ServiceValuationLanding> {
  return useCurrentPage<Page<ServiceValuationLanding>>();
}
